import type { SensitiveCredentialsApi } from './sensitive-credentials-api.types';

import http from './sensitive-credentials-api.http';

const DEFAULT_CREDENTIALS_PAGE = 1;
const DEFAULT_CREDENTIALS_PAGE_SIZE = 100;

export default {
  getCredentials: async ({
    partnerId,
    page = DEFAULT_CREDENTIALS_PAGE,
    pageSize = DEFAULT_CREDENTIALS_PAGE_SIZE,
  }: SensitiveCredentialsApi.GetCredentialsParams) => {
    const res = await http.get<SensitiveCredentialsApi.GetCredentialsResponse>(
      `/partners/${partnerId}/credentials`,
      { params: { page, pageSize } },
    );

    return res.data;
  },

  resetCredential: async ({
    credentialId,
    partnerId,
    payload,
  }: SensitiveCredentialsApi.ResetCredentialParams) => {
    const res = await http.delete<SensitiveCredentialsApi.ResetCredentialResponse>(
      `/partners/${partnerId}/credentials/${credentialId}`,
      { data: payload },
    );

    return res.data;
  },
};
